import { Backdrop, CircularProgress } from '@mui/material'
import React from 'react';

const LoaderComponent = ({open}) => {
  return (
    <Backdrop
    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1,zIndex:999999 }}
    open={open}
  >
    <CircularProgress size={80} color="inherit" />
  </Backdrop>
  )
}

export default LoaderComponent;